import { formatReportRatio } from '../helpers/reportRatio'
import React from 'react'
import AltRouteOutlined from '@mui/icons-material/AltRouteOutlined'
import AttachMoneyOutlined from '@mui/icons-material/AttachMoneyOutlined'
import BlockOutlined from '@mui/icons-material/BlockOutlined'
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined'
import PendingActionsOutlined from '@mui/icons-material/PendingActionsOutlined'
import TrendingUpOutlined from '@mui/icons-material/TrendingUpOutlined'
import { formatMoney } from '../../../helpers/utils'
import { buildActivityEffectivenessValues } from '../helpers/routeKpiValues'
import { formatLastActivity } from './reportMobileUserCardUtils'
import {
  formatPendingSettlementCount,
  formatPendingSettlementLabel,
  getPendingSettlementLabelColor
} from '../helpers/pendingSettlement'

const iconSize = { fontSize: 20 }

export function buildReportChargesUserMobileCardSections(model, { isSingleDayRange = true } = {}) {
  const effectiveness = buildActivityEffectivenessValues(model, 'charge').effectiveness
  const userName = model.user_name ?? '—'
  const visited = model.total_visited_in_route_clients ?? 0
  const attended = model.total_in_route_clients ?? 0
  const visitasStr = `${visited}/${attended}`
  const lastAct = formatLastActivity(model.last_visit)
  const pendingLabel = formatPendingSettlementLabel(model.settlement_status, isSingleDayRange)
  const pendingColor = getPendingSettlementLabelColor(pendingLabel)
  const pendingChargesCount = String(
    formatPendingSettlementCount(model.pending_charges_settlement_count, isSingleDayRange)
  )

  const summaryRows = [
    { label: 'Usuario', value: userName, valueTitle: userName },
    { label: 'Última actividad', value: lastAct, valueTitle: lastAct },
    { label: 'Visitas realizadas', value: visitasStr, valueTitle: visitasStr }
  ]

  const geo = formatReportRatio(model.geofence_activities_count, model.total_activities_count)
  const detailRows = [
    {
      icon: <AltRouteOutlined sx={iconSize} />,
      label: 'Visitas fuera de ruta',
      value: String(model.out_of_route_clients ?? 0),
      boldValue: true,
      valueTitle: String(model.out_of_route_clients ?? 0)
    },
    {
      icon: <TrendingUpOutlined sx={iconSize} />,
      label: 'Efectividad',
      value: `${Math.round(effectiveness)}%`,
      boldValue: true,
      valueTitle: `${Math.round(effectiveness)}%`
    },
    {
      icon: <LocationOnOutlined sx={iconSize} />,
      label: 'Actividades en geocerca',
      value: geo,
      boldValue: true,
      valueTitle: geo
    },
    {
      icon: <BlockOutlined sx={iconSize} />,
      label: 'Anulados',
      value: String(model.charge_cancelled_count ?? 0),
      boldValue: true,
      valueTitle: String(model.charge_cancelled_count ?? 0)
    },
    {
      icon: <PendingActionsOutlined sx={iconSize} />,
      label: 'Estado de liquidación',
      value: pendingLabel,
      boldValue: true,
      valueTitle: pendingLabel,
      valueSx: { color: pendingColor }
    },
    {
      icon: <PendingActionsOutlined sx={iconSize} />,
      label: 'Cobros pendientes por liquidar',
      value: pendingChargesCount,
      boldValue: true,
      valueTitle: pendingChargesCount
    },
    {
      icon: <AttachMoneyOutlined sx={iconSize} />,
      label: 'Total montos',
      value: formatMoney(model.total_charge),
      boldValue: true,
      valueTitle: formatMoney(model.total_charge)
    }
  ]

  return { summaryRows, detailRows }
}
